import { usePetitionDetailsPageData } from 'src/app/pages/petitionDetails/pageContext';

import { useTracking } from '../../../../../hooks/useTracking';

type Result = ModelHookResult<
	{
		petitionAsk: string;
	},
	{
		trackViewAllDMsWithinLegislativeBodyClick: (role: string) => void;
	}
>;

export function useViewMore(): Result {
	const {
		data: {
			petition: { ask },
		},
	} = usePetitionDetailsPageData();
	const { trackViewAllDMsWithinLegislativeBodyClick } = useTracking();

	return {
		data: {
			petitionAsk: ask,
		},
		actions: {
			trackViewAllDMsWithinLegislativeBodyClick,
		},
	};
}
